module.exports = __webpack_public_path__ + "static/media/ic_close_white.deac62b4.svg";